import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';
import { ChangeRequestItem } from '../models/change-request-item';
import { DocumentDetailDto } from '../../shared/models/document-details-dto';
import { UpdateChangeRequestItem } from '../models/update-change-request-item';

@Injectable({
  providedIn: 'root'
})
export class ChangeRequestItemService {

  constructor(private httpClient: HttpClient) { }

  createChangeRequestItem(changeRequestItem:ChangeRequestItem):Observable<any>{
    return this.httpClient.post(ApiConstants.CreateChangeRequestItem_Api,changeRequestItem);
  }

  getChangeRequestItems(documentDetails:DocumentDetailDto):Observable<any>{
    return this.httpClient.get(ApiConstants.GetChangeRequestItemsForDocument,
      {
        params: {
          documentNumber: documentDetails.number,
          version: documentDetails.version,
          documentPhase:documentDetails.phase
        }
      });
  }

  getChangeRequestItemById(id : string): Observable<any>{
    const headers = new HttpHeaders().set('X-No-Retry', 'true');
    return this.httpClient.get(ApiConstants.GetChangeRequestItemById + `${id}`, { headers : headers });
  }
  getChangeRequestRejectReasons():Observable<any>{
    return this.httpClient.get(ApiConstants.GetChangeRequestRejectionReasons);
  }

  updateChangeRequestItems(changeRequestItems:any):Observable<any>{
    return this.httpClient.put(ApiConstants.UpdateChangeRequestItem_Api,changeRequestItems);
  }

  getPeriodicReviewdateForDocumentVersion(documentNumber:any,documentVersion:any){
    return this.httpClient.get(ApiConstants.Get_PeriodicReviewDate_For_DocumentVersion +'/'+documentNumber+'/'+documentVersion);
  }

  getApproversForDocumentVersion(documentNumber:any){
    return this.httpClient.get(ApiConstants.DocumentDetailByVersion_Api + '/' + documentNumber + '/')
  }
}
